
<template>
  <div class="abr-view">
    <div ref="plot" class="abr-chart"></div>
  </div>
</template>

<script>
import PlayerComponent from '../PlayerComponent.vue';
import { AbrPlot, Series } from '../../../utils/plots';

export default {
  extends: PlayerComponent,
  name: 'PlotRenditions',
  props: {
    xaxis: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      abr_renditions: new Series(),
      playing_renditions: new Series(),
      chart_renditions: []
    };
  },
  watch: {
    chart_renditions (renditions) {
      if (this.chart) {
        this.chart.renditions = [...renditions].sort((a, b) => a.value - b.value);
        this.chart.draw();
      }
    }
  },
  mounted () {
    this.chart = new AbrPlot(this.$refs.plot, this.xaxis);
    // this.abr_renditions.strokeStyle = 'rgb(25,127,171)';
    this.abr_renditions.strokeStyle = 'rgba(25,127,171, 0)';
    this.abr_renditions.fillStyle = 'rgba(25,127,171,0.5)';
    this.playing_renditions.strokeStyle = 'rgb(194, 54, 51)';
    this.playing_renditions.fillStyle = 'rgba(171,129,0,0)';
    this.chart.addSeries(this.abr_renditions);
    this.chart.addSeries(this.playing_renditions);
    this.chart.init();
    this.chart.start();
    this.onTracksAdded();
    this.updatePlayingRendition();
    this.updatePlot();
  },
  destroyed () {
    if (this.chart) {
      this.chart.stop();
    }
  },
  methods: {
    bps (bps) {
      return bps ? '@' + clpp.utils.strings.bitrateToString(bps) : '';
    },

    updatePlayingRendition () {
      if (!this.ppPlayerRef) return;
      const trackManager = this.ppPlayerRef.get().getTrackManager();
      if (!trackManager) return;
      const active = trackManager.getVideoRendition();
      if (active) {
        this.playing_renditions.add(active.bandwidth);
        this.updatePlot();
      }
    },
    onVideoTrackChanged (event) {
      if (event && event.details) {
        this.abr_renditions.add(event.details.bandwidth);
        this.updatePlot();
      }
    },

    onBitrateChanged (event) {
      if (event && event.detail) {
        const bw = event.detail.bandwidth;
        if (bw) {
          this.playing_renditions.add(bw);
        } else {
          // If we do not have the information we need in the rendition list we will
          // not get get renditions for the player, i.e. native players such as safari.
          // In that case we need to add any new rendition that we observe here dynamically
          // to the list of renditions.
          const renditions = [];
          let max = 0;
          let exists = false;
          this.chart_renditions.forEach(t => {
            max = Math.max(t.value, max);
            renditions.push({
              width: t.width,
              height: t.height,
              label: `${t.width}x${t.height}`,
              value: t.value
            });
            if (t.width === event.detail.width) {
              exists = true;
            }
          });
          if (!exists && event.detail.width) {
            renditions.push({
              width: event.detail.width,
              height: event.detail.height,
              label: `${event.detail.width}x${event.detail.height}`,
              value: event.detail.width
            });
          }
          this.chart_renditions = renditions;
          this.chart.maxRendition = max;
          // We add the event, using width as the "bandwidth" since that is not used
          // and identifies the rendition as unique as we can make it. Renditions with
          // same resolution but different bandwidth will be merged since we have no
          // info about the bandwidth
          this.playing_renditions.add(event.detail.width);
        }
        this.updatePlot();
      }
    },

    onTracksAdded () {
      if (!this.ppPlayerRef || !this.chart) return;

      let max = 0;
      const trackManager = this.ppPlayerRef.get().getTrackManager();
      if (!trackManager) return;
      const videoTrack = trackManager.getVideoTrack();
      if (!videoTrack) return;

      const r = videoTrack.renditions;
      const renditions = [];
      // We only push the renditions on track update if we have the information we need there
      // Native player, i.e. Safari, will not expose them so we can not add it here but rather
      // deal with it dynamically on bitrate change
      r.forEach(t => {
        if (t.width && t.height && t.bandwidth) {
          max = Math.max(t.bandwidth, max);
          renditions.push({ label: `${t.width}x${t.height}${this.bps(t.bandwidth)}`, value: t.bandwidth });
        }
      });
      if (renditions.length > 0) {
        this.chart_renditions = renditions;
        this.chart.maxRendition = max;
      }
    },
    updatePlot () {
      if (!this.chart) return;
      this.chart.draw();
    },
    initPlayer (ppPlayerRef) {
      const ppPlayer = ppPlayerRef.get();
      ppPlayer.on('bitratechanged', this.onBitrateChanged);
      ppPlayer.on('videotrackchanged', this.onVideoTrackChanged);
      ppPlayer.on('tracksadded', this.onTracksAdded);
      ppPlayer.on('statechanged', this.onStateChange);
    },
    disposePlayer (ppPlayerRef) {
      const ppPlayer = ppPlayerRef.get();
      ppPlayer.off('bitratechanged', this.onBitrateChanged);
      ppPlayer.off('videotrackchanged', this.onVideoTrackChanged);
      ppPlayer.off('tracksadded', this.onTracksAdded);
      ppPlayer.off('statechanged', this.onStateChange);
    },
    onStateChange () {
      if (!this.chart) return;
      const state = this.ppPlayerRef.get().getState();
      if (state === clpp.Player.State.ENDED) {
        this.chart.stop();
      } else {
        this.chart.start();
      }
    }
  }
};
</script>

<style lang="scss" scoped>

  .abr-view {
  }

  .abr-chart {
  }

  .legend {

  }
</style>
